import { Stack } from '@mui/material';

const InstallApp: React.FC = () => {
  return (
    <Stack height="100vh" alignItems="center" justifyContent="center">
      <h2>Ainda não tem aplicativo instalado?</h2>
      <p>Acesse o link para acessar.</p>
    </Stack>
  );
};

export default InstallApp;
